export class PagedResponse<T> {
  results: T[];
  nextCursor: string;
  hasMore: boolean;

  constructor(results: T[], nextCursor: string, hasMore: boolean) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
  }
}
